module.exports = __webpack_public_path__ + "img/horizontal_6_1_8017.e286ac3a.png";